module.exports = "../img/GDA.jpg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/GDA.jpg
// module id = 31
// module chunks = 0